import React, { useEffect, useState } from "react";
import { MainSection, Text, TextBoxDiv, TopWrapper } from "./elements";
import NavbarComp from "components/homeCom/navbar";
import {
  arrowicon,
  c98img,
  connectbtnimg,
  eligableimg,
  mnotconnectimg,
  notconnectimg,
  textBox2,
} from "assets";
import { Image } from "react-bootstrap";
import MainSectionComp from "./mainSection";
import { useWalletConnectClient } from "services/walletServices";
import { Link } from "react-router-dom";
import { Modal } from "antd";
import ConnectModal from "components/common/modal/connectModel/connectModal";

const StakingComp = ({
  getUserNfts,
  getClaimedReward,
  getUserStaked,
  userBalance,
  userReward,
  staked,
  stakedDetail,
  userIds,
}) => {
  console.log("DATA", userBalance, userReward, staked, stakedDetail, userIds);
  const { web3Provider, account, chain } = useWalletConnectClient();
  const [elegibleText, setElegibleText] = useState(false);

  const showEligableText = () => {
    setElegibleText(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (web3Provider && account && chain) {
        await getUserNfts();
      }
    };
    fetchData();
  }, [web3Provider, account, chain]);
  useEffect(() => {
    const fetchData = async () => {
      if (web3Provider && account && chain) {
        await getUserStaked();
        await getClaimedReward();
      }
    };

    fetchData();
  }, [web3Provider, account, chain]);

  const [showModal, setShowModal] = useState(false);

  const showConnectModal = () => {
    setShowModal(true);
  };
  return (
    <>
      <Modal
        open={showModal}
        centered
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        width={714}
      >
        <ConnectModal closeModel={() => setShowModal(false)} />
      </Modal>
      <NavbarComp />
      <MainSection>
        {web3Provider && account && (
          <TextBoxDiv>
            <Image className="" src={textBox2} />
            <div>
              <h1 className="inner-text">
                Reward <span>Summary</span>
              </h1>
            </div>
          </TextBoxDiv>
        )}
        {web3Provider && (+userBalance > 0 || +staked > 0) ? (
          <>
            <MainSectionComp
              userReward={userReward}
              staked={staked}
              userIds={userIds}
              stakedDetail={stakedDetail}
              getUserNfts={getUserNfts}
              getClaimedReward={getClaimedReward}
              getUserStaked={getUserStaked}
            />
          </>
        ) : (
          <>
            <TopWrapper>
              {web3Provider && +userBalance == 0 && +staked == 0 ? (
                <>
                  <Image src={eligableimg} />
                  <Text>You have no eligible RetroCraft NFTs to stake</Text>
                  <Link to="/minting-nft">
                    <div className="register-btn-div">
                      <Image
                        src={connectbtnimg}
                        alt="button img"
                        className="btn-img"
                      />

                      <h1>
                        <Image src={arrowicon} />
                        &nbsp;&nbsp; Mint NFT Now
                      </h1>
                    </div>
                  </Link>
                </>
              ) : (
                <>
                  <Image src={notconnectimg} onClick={showEligableText} />

                  <Text>
                    Connect your wallet to check if you have any eligible NFT to
                    stake
                  </Text>
                  <div className="register-btn-div" onClick={showConnectModal}>
                    <Image
                      src={connectbtnimg}
                      alt="button img"
                      className="btn-img"
                    />

                    <h1>
                      <Image src={c98img} />
                      &nbsp;&nbsp; Connect Wallet
                    </h1>
                  </div>
                </>
              )}
            </TopWrapper>
          </>
        )}
      </MainSection>
    </>
  );
};

export default StakingComp;
